import { h } from 'preact';
import React, { Component } from 'react';
import Accordion from '../Components/Accordion';
import StackToggle from '../Stacks/StackToggle';
import { makeText, formatDescription } from '../../../util';

const SpecialPurposesList = ({
  disclosureOnlyPurposes,
  specialPurposesInfoText,
  specialPurposes, settings,
  force,
  updateMe,
  accordionOpen,
}) => {
  return (
    <div className="special-purposes-list">
      <p style="margin-bottom:15px;">{formatDescription(specialPurposesInfoText)}</p>
      {specialPurposes.map(p => (
        <StackToggle
          key={p._id}
          purpose={p}
          selected="vendors"
          settings={settings}
          force={force}
          updateMe={updateMe}
          parentAccordionOpen={accordionOpen}
          isSpecialPurpose
        />
      ))}
      {disclosureOnlyPurposes.length > 0 && disclosureOnlyPurposes.map(p => (
        <StackToggle
          key={p._id}
          purpose={p}
          selected="disclosure"
          settings={settings}
          force={force}
          updateMe={updateMe}
          parentAccordionOpen={accordionOpen}
        />
      ))}
    </div>
  )
}
export default class SpecialPurposes extends Component {
  render() {
    const {
      specialPurposes,
      disclosureOnlyPurposes,
      settings,
      language,
      force,
      updateMe,
      dev,
      usePurModel,
    } = this.props;

    const specialPurposesText = makeText(Boolean(dev), settings, 'specialPurposesText', language);
    const specialPurposesInfoText = makeText(Boolean(dev), settings, 'specialPurposesInfo', language);
    return (
      <Accordion
        settings={settings}
        name={specialPurposesText}
        child="specialPurposes-parent"
        language={language}
        value={null}
        force={force}
        updateMe={updateMe}
        description={null}
        content={<SpecialPurposesList disclosureOnlyPurposes={disclosureOnlyPurposes} specialPurposesInfoText={specialPurposesInfoText} specialPurposes={specialPurposes} settings={settings} language={language} force={force} dev={dev} updateMe={updateMe} />}
        usePurModel={usePurModel}
      />
    );
  }
}
